function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var SCREEN_CLASSES = ['xs', 'sm', 'md', 'lg', 'xl'];
/**
 * Map of Screen Classes to their max-pixel-widths
 */

var SCREEN_CLASS_MAX_WIDTHS = {
  xs: 767,
  sm: 1023,
  md: 1439,
  lg: 1919,
  xl: Infinity
};
/**
 * Map of Screen Classes to their min-pixel-widths
 */

var SCREEN_CLASS_MIN_WIDTHS = {
  xs: 0,
  sm: 768,
  md: 1024,
  lg: 1440,
  xl: 1920
};
/**
 * Returns the Screen Class corresponding to the given width
 *
 * @param windowWidth - the width (in px) of the window/screen
 */

function getScreenClass(windowWidth) {
  var _iterator = _createForOfIteratorHelper(SCREEN_CLASSES),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var screenClass = _step.value;
      var maxWidth = SCREEN_CLASS_MAX_WIDTHS[screenClass];
      var minWidth = SCREEN_CLASS_MIN_WIDTHS[screenClass];

      if (windowWidth >= minWidth && windowWidth <= maxWidth) {
        return screenClass;
      }
    } // the loop above should be guaranteed to return a value
    // if we hit this error, we messed up

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  throw new Error('Misconfigured screen classes.');
}

export { SCREEN_CLASSES, SCREEN_CLASS_MAX_WIDTHS, SCREEN_CLASS_MIN_WIDTHS, getScreenClass };